// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store/store'
import axios from './http'

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faHistory, faCloud, faCameraRetro, faCamera,
  faSearch, faUserTie, faUsers, faUserFriends, faListAlt, faCog,
  faSignOutAlt} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret, faHistory, faCloud, faCameraRetro, faCamera, faSearch, faUserTie, faUsers, faUserFriends, faListAlt, faCog, faSignOutAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)
// End of Font Awesome

Vue.config.productionTip = false

Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js